<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           :width="700"
           @on-cancel="cancel"
           :ok-text="'保存'"
    >
      <h3 slot="header" class="modal-header">添加业绩公式</h3>
      <section class="mb32">
        <Form :label-width=80 class="mb16">
          <FormItem class="notip ivu-form-item-required" label="公式名称" style="align-items: center">
            <Input style="width: 200px;" v-model="formulaName"></Input>
          </FormItem>
          <br>

          <FormItem class="notip ivu-form-item-required" label="公式">
            <div class="flex">
              <div class="textarea flex" style="flex-wrap: wrap;">

                <div v-for="item in formula">
                  <span v-if="item.showType==='express'" class="express">{{item.text}}</span>
                  <span v-if="item.showType==='meta'" class="meta">{{item.fieldName}}</span>
                  <span v-if="item.showType==='formula'" class="formula">{{item.formulaName}}</span>

                </div>
              </div>
              <Button @click.stop="back" style="height: 30px;margin-left: 20px"> <Icon type="arrow-left-c"></Icon></Button>

            </div>


          </FormItem>
        </Form>

      </section>
      <div class="flex " style="justify-content: space-between">
        <section>
          <div class="text-align-c mb8">选择元数据</div>
          <div class="box">
            <Input placeholder="搜索元数据" v-model="metaWord"></Input>
            <div @click.stop="clickMeta(item)" class="item" v-for="item in filterMetaList">{{item.fieldName}}</div>
          </div>
        </section>
        <section>
          <div class="text-align-c mb8">选择公式</div>
          <div class="box">
            <Input v-model="formulaWord" placeholder="搜索公式名称"></Input>
            <div @click.stop="clickFormula(item)" class="item" v-for="item in filterFormulaList">{{item.formulaName}}
            </div>
          </div>
        </section>
        <section>
          <div class="text-align-c mb8">输入表达式</div>
          <div class="box">
            <calculator @clickitem="clickCalculate"></calculator>
          </div>
        </section>
      </div>
    </Modal>
  </div>

</template>
<script>
  import Calculator from './Calculator'
  import {saveFormula} from "../../../../../api/performula";
  import {allMeta} from "../../../../../api/meta";
  import {allFormula} from "../../../../../api/performula";

  export default {
    name: "",
    components: {
      Calculator
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      // metaList: {
      //   type: Array,
      //   defalut: () => {
      //     return []
      //   }
      // },
      // formulaList: {
      //   type: Array,
      //   defalut: () => {
      //     return []
      //   }
      //
      // }
    },
    computed: {

      filterMetaList() {
        if (!(this.metaWord + '')) {
          return this.metaList
        }
        return this.metaList.filter(ele => {
          return ele.fieldName.indexOf(this.metaWord) !== -1
        })
      },
      filterFormulaList() {
        if (!(this.formulaWord + '')) {
          return this.formulaList
        }
        return this.formulaList.filter(ele => {
          return ele.formulaName.indexOf(this.formulaWord) !== -1
        })
      },

    },
    watch: {
      n() {
        this.allMeta()
        this.allFormula()
        this.formula = []
        this.formulaName = ''
        this.isShow = true
      }
    },
    data() {
      return {
        metaList:[],
        formulaList:[],
        loading: true,
        isShow: false,
        formula: [],
        formulaName: '',
        metaWord: '',
        formulaWord: ''
      }
    },
    methods: {
      allFormula(){
        allFormula().then(res=>{
          if(!res.data){
            return
          }
          this.formulaList=res.data

        }).catch(error=>{

        })
      },
      allMeta(){
        allMeta().then(res=>{
          if(!res.data){
            return
          }
          this.metaList=res.data
        }).catch(error=>{
        })

      },
      back() {
        this.formula.pop()
      },
      clickFormula(item) {
        this.formula.push({
          ...item,
          showType: 'formula'
        })
      },
      clickMeta(item) {
        this.formula.push({
          ...item,
          showType: 'meta'
        })
      },
      clickCalculate(data) {
        this.formula.push({
          text: data,
          showType: 'express'
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!(this.formulaName + '') || !this.formula.length) {
          this.$Message.info('公式名称与公式不能为空！')
          this.changeLoading()
          return
        }
        let express = []
        console.log(this.formula,'公式')
        this.formula.forEach(ele => {
          if (ele.showType === 'meta') {
            express.push('{' + ele.fieldKey + '}')
          }
          if (ele.showType === 'formula') {
            express.push('[' + ele.formulaKey + ']')

          }
          if (ele.showType === 'express') {
            express.push(ele.text)
          }
        })
        let params = {
          formulaName: this.formulaName,
          expression: express.join('')
        }
        saveFormula(params).then(res => {
          this.$Message.success('保存成功')
          this.$emit('done')

        }).catch(error => {
          this.$Message.info('保存失败')
        }).finally(() => {
          this.isShow = false
        })
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .express {
    padding: 2px 4px;

  }

  .meta, .formula {
    padding: 2px 5px;
    border-radius: 4px;
    font-weight: bold;
    margin-right: 5px;
    margin-bottom: 8px;
    display: inline-block;
  }

  .meta {
    background-color: red;

    color: white;
  }

  .formula {
    background-color: #85CC7A;
    color: white;
  }

  .formwidth {
    width: 100px;
    display: inline-block;
  }

  .inputwidth {
    width: 80px;
  }

  .name {
    width: 60px;
    text-align: right;
    margin-right: 10px;
  }


  .box {
    width: 200px;
    height: 300px;
    border: 1px solid rgb(220, 220, 220);
    padding: 10px;
    box-sizing: border-box;
    overflow: scroll;

  }

  .textarea {
    width: 400px;
    min-height: 80px;
    border: 1px solid rgb(220, 220, 220);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
  }

  .item {
    padding-left: 10px;
    line-height: 2;
    cursor: pointer;

    /*margin-top: 8px;*/
  }


</style>
